(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (() => {
    const init = () => {
      const form = document.querySelector('.cart-form:not([data-cart-init])');
      if (!form) return;
      form.setAttribute('data-cart-init', '');
      form.querySelectorAll('.cart-line').forEach((line) => {
        const qty = line.querySelector('[data-line-qty]');
        line.querySelector('[data-line-minus]').addEventListener('click', () => {
          qty.value = Math.max(0, parseInt(qty.value || '1', 10) - 1);
          form.submit();
        });
        line.querySelector('[data-line-plus]').addEventListener('click', () => {
          qty.value = Math.min(99, parseInt(qty.value || '1', 10) + 1);
          form.submit();
        });
        qty.addEventListener('change', () => form.submit());
      });
    };
    init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-collage"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = () => {
      if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (!matchMedia('(pointer: fine)').matches) return;
      document.querySelectorAll('[data-hero-scene]:not([data-hero-init])').forEach((scene) => {
        scene.setAttribute('data-hero-init', '');
        const hero = scene.closest('.hero-collage');
        let raf = null;
        let mx = 0;
        let my = 0;
        let lastSpark = 0;
        hero.addEventListener('pointermove', (e) => {
          const r = hero.getBoundingClientRect();
          mx = ((e.clientX - r.left) / r.width - 0.5) * 14;
          my = ((e.clientY - r.top) / r.height - 0.5) * 10;
          if (!raf) {
            raf = requestAnimationFrame(() => {
              raf = null;
              scene.style.setProperty('--mx', mx.toFixed(1) + 'px');
              scene.style.setProperty('--my', my.toFixed(1) + 'px');
            });
          }

          /* Sparkle trail: one every ~90ms, capped, self-removing */
          const now = performance.now();
          if (now - lastSpark > 90 && hero.querySelectorAll('.hero-spark').length < 14) {
            lastSpark = now;
            const s = document.createElement('span');
            s.className = 'hero-spark';
            s.textContent = '✦';
            s.setAttribute('aria-hidden', 'true');
            s.style.left = (e.clientX - r.left) + 'px';
            s.style.top = (e.clientY - r.top) + 'px';
            s.style.fontSize = (8 + Math.random() * 10) + 'px';
            hero.appendChild(s);
            s.addEventListener('animationend', () => s.remove());
          }
        });
        hero.addEventListener('pointerleave', () => {
          scene.style.setProperty('--mx', '0px');
          scene.style.setProperty('--my', '0px');
        });
      });
    };
    init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (() => {
    const init = () => {
      const form = document.getElementById('CollectionFilters');
      if (!form || form.hasAttribute('data-filters-init')) return;
      form.setAttribute('data-filters-init', '');

      // Auto-apply on any filter change (the sort select lives outside the
      // form and is linked via form="CollectionFilters")
      const submitOnChange = (e) => {
        if (e.target.matches('input[type="checkbox"], input[type="number"], select[name="sort_by"]')) {
          form.submit();
        }
      };
      form.addEventListener('change', submitOnChange);
      document.querySelectorAll('select[form="CollectionFilters"]').forEach((el) => {
        el.addEventListener('change', submitOnChange);
      });

      // Sidebar starts collapsed on small screens
      const sidebar = document.querySelector('[data-sidebar]');
      if (sidebar && window.matchMedia('(max-width: 940px)').matches) {
        sidebar.removeAttribute('open');
      }
    };

    // Themed banner Lottie: lazy-load the self-hosted player only when a
    // slot exists, then play (or park on a mid frame for reduced motion).
    let playerPromise = null;
    const loadPlayer = (src) => {
      if (window.lottie) return Promise.resolve();
      playerPromise =
        playerPromise ||
        new Promise((resolve, reject) => {
          const s = document.createElement('script');
          s.src = src;
          s.onload = resolve;
          s.onerror = reject;
          document.head.appendChild(s);
        });
      return playerPromise;
    };

    const initLottie = () => {
      const slot = document.querySelector('[data-lottie-src]:not([data-lottie-init])');
      if (!slot) return;
      slot.setAttribute('data-lottie-init', '');
      const motionOK = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      /* The player is ~43KB gzipped for a decorative badge. Hold it until the
         slot is actually near the viewport and the main thread is idle, so it
         never competes with the catalogue on a slow connection. */
      const start = () => mountLottie(slot, motionOK);
      const whenIdle = (fn) => (window.requestIdleCallback || setTimeout)(fn, { timeout: 2000 });
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver(
          (entries, obs) => {
            if (!entries.some((e) => e.isIntersecting)) return;
            obs.disconnect();
            whenIdle(start);
          },
          { rootMargin: '200px' }
        );
        io.observe(slot);
      } else {
        whenIdle(start);
      }
    };

    const mountLottie = (slot, motionOK) => {
      loadPlayer(slot.dataset.lottiePlayer)
        .then(() => {
          const anim = window.lottie.loadAnimation({
            container: slot,
            renderer: 'svg',
            loop: true,
            autoplay: motionOK,
            path: slot.dataset.lottieSrc,
          });
          if (!motionOK) {
            anim.addEventListener('DOMLoaded', () => {
              anim.goToAndStop(Math.floor(anim.totalFrames * 0.4), true);
            });
          }
        })
        .catch(() => slot.remove());
    };

    init();
    initLottie();
    document.addEventListener('shopify:section:load', () => {
      init();
      initLottie();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (() => {
    const init = () => {
      const root = document.querySelector('[data-pdp]:not([data-pdp-init])');
      if (!root) return;
      root.setAttribute('data-pdp-init', '');

      const form = root.querySelector('[data-product-form]') || document.getElementById('ProductForm');
      const variantData = JSON.parse(document.querySelector('[data-variant-data]').textContent);
      const idInput = root.querySelector('[data-variant-id]');
      const priceCurrent = root.querySelector('[data-price-current]');
      const priceCompare = root.querySelector('[data-price-compare]');
      const addButton = root.querySelector('[data-add-button]');
      const addLabel = root.querySelector('[data-add-label]');
      const status = root.querySelector('[data-form-status]');
      const mainMedia = root.querySelector('[data-main-media]');
      const soldOutText = root.dataset.textSoldout;
      const addText = root.dataset.textAdd;
      const addedText = root.dataset.textAdded;
      const addingText = root.dataset.textAdding;
      const addNamedTemplate = root.dataset.textAddNamed;
      const motionOK = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      /* Gallery: thumbnails swap the active media */
      const showMedia = (mediaId) => {
        root.querySelectorAll('.pdp__media-item').forEach((m) => {
          m.classList.toggle('is-active', m.dataset.mediaId === String(mediaId));
        });
        root.querySelectorAll('.pdp__thumb').forEach((t) => {
          t.classList.toggle('is-active', t.dataset.thumbFor === String(mediaId));
        });
        mainMedia.classList.remove('is-zoomed');
      };
      root.querySelectorAll('.pdp__thumb').forEach((t) => {
        t.addEventListener('click', () => showMedia(t.dataset.thumbFor));
      });

      /* Zoom: click-to-zoom on the image, disabled while customizing —
         the corner zoom button always works instead. */
      mainMedia.addEventListener('click', (e) => {
        if (root.classList.contains('is-customizing')) return;
        if (!e.target.classList.contains('pdp__image')) return;
        const zoomed = mainMedia.classList.toggle('is-zoomed');
        if (zoomed) {
          const r = e.target.getBoundingClientRect();
          e.target.style.transformOrigin =
            (((e.clientX - r.left) / r.width) * 100).toFixed(1) + '% ' +
            (((e.clientY - r.top) / r.height) * 100).toFixed(1) + '%';
        }
      });
      const zoomBtn = root.querySelector('[data-zoom-toggle]');
      if (zoomBtn) {
        zoomBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          const img = mainMedia.querySelector('.pdp__media-item.is-active .pdp__image');
          if (img) img.style.transformOrigin = '50% 50%';
          mainMedia.classList.toggle('is-zoomed');
        });
      }

      /* Variant pills -> resolve variant, update price/availability/media */
      const currentOptions = () =>
        Array.from(root.querySelectorAll('.pdp__option')).map(
          (o) => o.querySelector('input:checked')?.value
        );
      const onOptionChange = () => {
        const opts = currentOptions();
        const variant = variantData.find((v) => v.options.every((val, i) => val === opts[i]));
        if (!variant) {
          addButton.disabled = true;
          addLabel.textContent = soldOutText;
          return;
        }
        idInput.value = variant.id;
        priceCurrent.textContent = variant.price_html;
        priceCurrent.classList.toggle('pdp__price-current--sale', !!variant.compare_html);
        if (variant.compare_html) {
          priceCompare.textContent = variant.compare_html;
          priceCompare.hidden = false;
        } else {
          priceCompare.hidden = true;
        }
        addButton.disabled = !variant.available;
        addLabel.textContent = variant.available ? computeAddLabel() : soldOutText;
        if (variant.media_id) showMedia(variant.media_id);
        const url = new URL(location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url);
      };
      root.querySelectorAll('.pdp__option input').forEach((i) => {
        i.addEventListener('change', onOptionChange);
      });

      /* Quantity stepper */
      const qty = root.querySelector('input[name="quantity"]');
      root.querySelector('[data-qty-minus]').addEventListener('click', () => {
        qty.value = Math.max(1, parseInt(qty.value || '1', 10) - 1);
      });
      root.querySelector('[data-qty-plus]').addEventListener('click', () => {
        qty.value = Math.min(99, parseInt(qty.value || '1', 10) + 1);
      });

      /* Live name preview over the photo + personalized add-button label */
      const nameInput = root.querySelector('[data-name-input]');
      const overlay = root.querySelector('[data-name-overlay]');
      const computeAddLabel = () => {
        const n = nameInput ? nameInput.value.trim() : '';
        return n ? addNamedTemplate.replace('[name]', n) : addText;
      };
      if (nameInput) {
        nameInput.addEventListener('input', () => {
          if (overlay) overlay.textContent = nameInput.value.trim();
          if (!addButton.disabled && addLabel.textContent !== addingText && addLabel.textContent !== addedText) {
            addLabel.textContent = computeAddLabel();
          }
        });
      }

      /* Customizer style controls -> live overlay */
      const FONT_FAMILIES = {
        script: "'Caveat', 'Segoe Script', cursive",
        clean: 'Inter, sans-serif',
        bold: 'Poppins, sans-serif',
        rounded: "'Baloo 2', sans-serif",
        elegant: "'Playfair Display', serif",
      };
      const sizeSlider = root.querySelector('[data-cz-size-slider]');
      const sizeProp = root.querySelector('[data-cz-size-prop]');
      const currentFont = () => root.querySelector('[data-cz-font]:checked')?.dataset.czFont || 'script';
      const currentColor = () => root.querySelector('[data-cz-color]:checked')?.dataset.czColor || '#211E3B';
      const currentScale = () => (sizeSlider ? parseInt(sizeSlider.value, 10) / 100 : 1);

      const applyStyles = () => {
        const font = currentFont();
        if (overlay) {
          overlay.classList.toggle('pv-font-clean', font === 'clean');
          overlay.classList.toggle('pv-font-bold', font === 'bold');
          overlay.classList.toggle('pv-font-rounded', font === 'rounded');
          overlay.classList.toggle('pv-font-elegant', font === 'elegant');
          overlay.style.setProperty('--pv-color', currentColor());
          overlay.style.setProperty('--pv-scale', currentScale());
        }
        if (sizeProp && sizeSlider) sizeProp.value = sizeSlider.value + '%';
        document.querySelectorAll('.pdp__design-obj--clipart').forEach((c) => {
          c.style.color = currentColor();
        });
      };
      root.querySelectorAll('[data-cz-font], [data-cz-color]').forEach((i) => {
        i.addEventListener('change', applyStyles);
      });
      if (sizeSlider) sizeSlider.addEventListener('input', applyStyles);
      applyStyles();

      /* ---------- Designer view: place, resize, rotate on the photo ---------- */
      const printArea = mainMedia.querySelector('[data-print-area]');
      const placementName = root.querySelector('[data-placement-name]');
      if (printArea) mainMedia.classList.add('is-designable');

      const mediaRect = () => mainMedia.getBoundingClientRect();
      const areaBounds = () => {
        const m = mediaRect();
        const a = printArea ? printArea.getBoundingClientRect() : m;
        return {
          minX: ((a.left - m.left) / m.width) * 100,
          maxX: ((a.right - m.left) / m.width) * 100,
          minY: ((a.top - m.top) / m.height) * 100,
          maxY: ((a.bottom - m.top) / m.height) * 100,
        };
      };
      const clamp = (v, lo, hi) => Math.min(hi, Math.max(lo, v));
      const designing = (on) => mainMedia.classList.toggle('is-designing', on);

      /* Design objects: brand cliparts (up to 6), shared engine */
      const clipartProp = root.querySelector('[data-clipart-prop]');
      const designObjects = [];

      const syncClipartPlacement = () => {
        if (!clipartProp) return;
        const cliparts = designObjects.filter((o) => o.kind === 'clipart');
        clipartProp.disabled = cliparts.length === 0;
        if (cliparts.length) {
          clipartProp.value = cliparts
            .map((o) => o.name + ' (x ' + o.state.x.toFixed(0) + '% · y ' + o.state.y.toFixed(0) + '% · w ' + o.state.w.toFixed(0) + '% · r ' + o.state.rot.toFixed(0) + '°)')
            .join('; ');
        }
      };

      const applyObjState = (obj) => {
        obj.el.style.left = obj.state.x + '%';
        obj.el.style.top = obj.state.y + '%';
        obj.el.style.width = obj.state.w + '%';
        obj.el.style.rotate = obj.state.rot + 'deg';
        syncClipartPlacement();
      };

      const dragPointer = (el, onMove, onStart, onEnd) => {
        el.addEventListener('pointerdown', (e) => {
          e.preventDefault();
          e.stopPropagation();
          el.setPointerCapture(e.pointerId);
          designing(true);
          if (onStart) onStart(e);
          const move = (ev) => onMove(ev);
          const up = () => {
            el.removeEventListener('pointermove', move);
            el.removeEventListener('pointerup', up);
            el.removeEventListener('pointercancel', up);
            designing(false);
            if (onEnd) onEnd();
          };
          el.addEventListener('pointermove', move);
          el.addEventListener('pointerup', up);
          /* Touch gestures get cancelled by scroll takeover and incoming
             calls; without this the move handler stays bound forever and
             every later drag stacks another one. */
          el.addEventListener('pointercancel', up);
        });
      };

      /* Cliparts: brand stickers, up to 6, tinted by the print colour */
      const createClipart = (name, svgHTML) => {
        if (designObjects.filter((o) => o.kind === 'clipart').length >= 6) return;
        const el = document.createElement('div');
        el.className = 'pdp__design-obj pdp__design-obj--clipart';
        el.setAttribute('tabindex', '0');
        el.style.color = currentColor();
        el.innerHTML =
          svgHTML +
          '<span class="pdp__design-handle pdp__design-handle--rotate" data-h-rotate aria-hidden="true"></span>' +
          '<span class="pdp__design-handle pdp__design-handle--resize" data-h-resize aria-hidden="true"></span>' +
          '<button class="pdp__design-handle pdp__design-handle--remove" type="button" data-h-remove aria-label="Remove clipart">×</button>';
        mainMedia.appendChild(el);
        const obj = {
          kind: 'clipart',
          name,
          el,
          state: { x: 42 + Math.random() * 16, y: 40 + Math.random() * 16, w: 14, rot: 0 },
        };
        designObjects.push(obj);
        dragPointer(el, (e) => {
          const m = mediaRect();
          const b = areaBounds();
          obj.state.x = clamp(((e.clientX - m.left) / m.width) * 100, b.minX, b.maxX);
          obj.state.y = clamp(((e.clientY - m.top) / m.height) * 100, b.minY, b.maxY);
          applyObjState(obj);
        });
        dragPointer(el.querySelector('[data-h-resize]'), (e) => {
          const m = mediaRect();
          const cx = m.left + (obj.state.x / 100) * m.width;
          obj.state.w = clamp(((Math.abs(e.clientX - cx) * 2) / m.width) * 100, 6, 40);
          applyObjState(obj);
        });
        dragPointer(el.querySelector('[data-h-rotate]'), (e) => {
          const m = mediaRect();
          const cx = m.left + (obj.state.x / 100) * m.width;
          const cy = m.top + (obj.state.y / 100) * m.height;
          let deg = (Math.atan2(e.clientY - cy, e.clientX - cx) * 180) / Math.PI + 90;
          if (deg > 180) deg -= 360;
          if (Math.abs(deg) < 4) deg = 0;
          obj.state.rot = deg;
          applyObjState(obj);
        });
        const clipartRemove = el.querySelector('[data-h-remove]');
        clipartRemove.addEventListener('pointerdown', (e) => e.stopPropagation());
        clipartRemove.addEventListener('click', () => {
          el.remove();
          designObjects.splice(designObjects.indexOf(obj), 1);
          syncClipartPlacement();
        });
        applyObjState(obj);
        designing(true);
        setTimeout(() => designing(false), 1200);
      };
      root.querySelectorAll('[data-clipart]').forEach((btn) => {
        btn.addEventListener('click', () => createClipart(btn.dataset.clipart, btn.querySelector('svg').outerHTML));
      });

      /* Final design preview: composite everything onto a canvas */
      const generatePreview = async () => {
        const activeImg = mainMedia.querySelector('.pdp__media-item.is-active img');
        if (!activeImg) return null;
        /* 600px JPEG, not 1200px PNG: this blob is generated and uploaded
           before cart/add fires, so on a slow mobile connection its size is
           add-to-cart latency. PNG also ignores the quality argument, which
           made every upload multi-megabyte. 600px is ample for a proof. */
        const S = 600;
        const canvas = document.createElement('canvas');
        canvas.width = canvas.height = S;
        const ctx = canvas.getContext('2d');
        ctx.fillStyle = getComputedStyle(mainMedia).backgroundColor;
        ctx.fillRect(0, 0, S, S);
        const base = new Image();
        base.crossOrigin = 'anonymous';
        base.src = activeImg.currentSrc || activeImg.src;
        await new Promise((res, rej) => { base.onload = res; base.onerror = rej; });
        ctx.globalCompositeOperation = 'multiply';
        const bw = S * 0.86;
        const bh = S * 0.92;
        const sc = Math.min(bw / base.width, bh / base.height);
        ctx.drawImage(base, (S - base.width * sc) / 2, (S - base.height * sc) / 2, base.width * sc, base.height * sc);
        ctx.globalCompositeOperation = 'source-over';

        const drawObj = (img, st) => {
          const w = (st.w / 100) * S;
          const h = w * (img.height / img.width || 1);
          ctx.save();
          ctx.translate((st.x / 100) * S, (st.y / 100) * S);
          ctx.rotate((st.rot * Math.PI) / 180);
          ctx.shadowColor = 'rgba(33,30,59,.3)';
          ctx.shadowBlur = 16;
          ctx.drawImage(img, -w / 2, -h / 2, w, h);
          ctx.restore();
        };

        for (const o of designObjects.filter((o) => o.kind === 'clipart')) {
          const svg = o.el.querySelector('svg').cloneNode(true);
          svg.setAttribute('fill', currentColor());
          svg.setAttribute('width', '200');
          svg.setAttribute('height', '200');
          svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
          const url = URL.createObjectURL(new Blob([new XMLSerializer().serializeToString(svg)], { type: 'image/svg+xml' }));
          const im = new Image();
          im.src = url;
          await new Promise((r) => { im.onload = r; });
          drawObj(im, o.state);
          URL.revokeObjectURL(url);
        }
        const nameText = nameInput ? nameInput.value.trim() : '';
        if (nameText && overlay) {
          const fam = FONT_FAMILIES[currentFont()];
          const px = S * 0.073 * currentScale();
          try { await document.fonts.load('600 ' + px + 'px ' + fam.split(',')[0].replace(/'/g, '')); } catch (err) { /* draw with fallback */ }
          const placed = overlay.classList.contains('is-placed');
          const st = placed
            ? { x: parseFloat(overlay.style.left) || 50, y: parseFloat(overlay.style.top) || 58 }
            : { x: 50, y: 58 };
          ctx.save();
          ctx.translate((st.x / 100) * S, (st.y / 100) * S);
          if (currentFont() === 'script') ctx.rotate((-6 * Math.PI) / 180);
          ctx.font = '600 ' + px + 'px ' + fam;
          ctx.fillStyle = currentColor();
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';
          ctx.shadowColor = 'rgba(33,30,59,.25)';
          ctx.shadowBlur = 8;
          ctx.fillText(nameText, 0, 0);
          ctx.restore();
        }
        return await new Promise((res) => canvas.toBlob(res, 'image/jpeg', 0.82));
      };

      /* Name overlay: draggable within the print area too */
      const nameOverlayDrag = root.querySelector('[data-name-overlay]');
      if (nameOverlayDrag && printArea) {
        const nameState = { x: 50, y: 58 };
        const syncNamePlacement = () => {
          if (!placementName) return;
          const has = nameOverlayDrag.textContent.trim() !== '' && nameOverlayDrag.classList.contains('is-placed');
          placementName.disabled = !has;
          if (has) placementName.value = 'x ' + nameState.x.toFixed(0) + '% · y ' + nameState.y.toFixed(0) + '%';
        };
        dragPointer(nameOverlayDrag, (e) => {
          if (nameOverlayDrag.textContent.trim() === '') return;
          const m = mediaRect();
          const b = areaBounds();
          nameState.x = clamp(((e.clientX - m.left) / m.width) * 100, b.minX, b.maxX);
          nameState.y = clamp(((e.clientY - m.top) / m.height) * 100, b.minY, b.maxY);
          nameOverlayDrag.classList.add('is-placed');
          nameOverlayDrag.style.left = nameState.x + '%';
          nameOverlayDrag.style.top = nameState.y + '%';
          syncNamePlacement();
        }, null, syncNamePlacement);
      }

      /* Customize button: jump to the personalization box and light it up */
      const jumpBtn = root.querySelector('[data-customize-jump]');
      const personalizeBox = root.querySelector('[data-personalize-box]');
      if (jumpBtn && personalizeBox) {
        jumpBtn.addEventListener('click', () => {
          const first = !root.classList.contains('is-customizing');
          root.classList.add('is-customizing');
          jumpBtn.setAttribute('aria-pressed', 'true');
          mainMedia.classList.remove('is-zoomed');
          if (first) {
            designing(true);
            setTimeout(() => designing(false), 1600);
          }
          personalizeBox.scrollIntoView({ behavior: motionOK ? 'smooth' : 'auto', block: 'center' });
          personalizeBox.classList.remove('is-pulsed');
          void personalizeBox.offsetWidth;
          personalizeBox.classList.add('is-pulsed');
          setTimeout(() => nameInput && nameInput.focus({ preventScroll: true }), motionOK ? 420 : 0);
        });
      }

      /* Touch swipe on the gallery (skip when interacting with designer objects) */
      let touchX = null;
      mainMedia.addEventListener('touchstart', (e) => {
        if (e.target.closest('.pdp__design-obj, .pdp__name-overlay')) return;
        touchX = e.touches[0].clientX;
      }, { passive: true });
      mainMedia.addEventListener('touchend', (e) => {
        if (touchX === null) return;
        const dx = e.changedTouches[0].clientX - touchX;
        touchX = null;
        if (Math.abs(dx) < 40) return;
        const items = Array.from(root.querySelectorAll('.pdp__media-item'));
        if (items.length < 2) return;
        const cur = items.findIndex((m) => m.classList.contains('is-active'));
        const next = (cur + (dx < 0 ? 1 : -1) + items.length) % items.length;
        showMedia(items[next].dataset.mediaId);
      }, { passive: true });

      /* Sticky buy bar: shows when the main add-to-cart is out of view.
         Price and label sync by observing the live elements, so variant
         changes and the "Adding…/Added" states carry over for free. */
      const stickyBar = document.querySelector('[data-sticky-bar]:not([data-sticky-init])');
      if (stickyBar && addButton && 'IntersectionObserver' in window) {
        stickyBar.setAttribute('data-sticky-init', '');
        const stickyAdd = stickyBar.querySelector('[data-sticky-add]');
        const stickyPrice = stickyBar.querySelector('[data-sticky-price]');
        const mainPrice = root.querySelector('[data-price-current]');

        const sync = () => {
          if (mainPrice && stickyPrice) stickyPrice.textContent = mainPrice.textContent.trim();
          stickyAdd.disabled = addButton.disabled;
          if (addLabel) stickyAdd.textContent = addLabel.textContent;
        };
        sync();
        new MutationObserver(sync).observe(addButton, { attributes: true, childList: true, subtree: true, characterData: true });
        if (mainPrice) new MutationObserver(sync).observe(mainPrice, { childList: true, characterData: true, subtree: true });

        stickyAdd.addEventListener('click', () => {
          if (form.requestSubmit) form.requestSubmit();
          else form.submit();
        });

        const headerSection = (document.querySelector('.site-header') || {}).closest
          ? document.querySelector('.site-header').closest('.shopify-section')
          : null;
        const placeBar = () => {
          const mobile = window.matchMedia('(max-width: 940px)').matches;
          if (!mobile && headerSection) {
            // Dock under the sticky header's live bottom edge
            stickyBar.style.top = Math.max(0, Math.round(headerSection.getBoundingClientRect().bottom)) + 'px';
          } else {
            stickyBar.style.top = '';
          }
        };
        new IntersectionObserver((entries) => {
          const show = !entries[0].isIntersecting;
          placeBar();
          stickyBar.classList.toggle('is-visible', show);
          // Lift the floating WhatsApp button above the bottom bar on mobile
          const mobile = window.matchMedia('(max-width: 940px)').matches;
          document.documentElement.style.setProperty('--wa-offset', show && mobile ? '72px' : '0px');
        }).observe(addButton);
        window.addEventListener('resize', () => {
          if (stickyBar.classList.contains('is-visible')) placeBar();
        });
      }

      /* AJAX add to cart with graceful fallback */
      form.addEventListener('submit', async (e) => {
        if (!window.fetch) return;
        e.preventDefault();
        status.textContent = '';
        status.classList.remove('is-error');
        addLabel.textContent = addingText;
        addButton.disabled = true;

        const fd = new FormData(form);
        // Drop empty personalization properties so the cart stays clean;
        // with no personalization at all, drop the style properties too.
        const hasName = nameInput && nameInput.value.trim() !== '';
        const hasCliparts = designObjects.some((o) => o.kind === 'clipart');
        const hasDesign = hasName || hasCliparts;
        for (const [key, value] of Array.from(fd.entries())) {
          if (!key.startsWith('properties[')) continue;
          if (value instanceof File) {
            if (value.size === 0) fd.delete(key);
            continue;
          }
          if (String(value).trim() === '') fd.delete(key);
        }
        if (!hasDesign) {
          root.querySelectorAll('[data-cz-style] input').forEach((i) => fd.delete(i.name));
        }

        // Attach the rendered design as a file property on the order
        if (hasDesign && root.dataset.propPreview) {
          try {
            const blob = await generatePreview();
            if (blob) {
              fd.append(root.dataset.propPreview, new File([blob], 'design-preview.jpg', { type: 'image/jpeg' }));
            }
          } catch (err) {
            /* CORS or render failure: order still carries all placement data */
          }
        }

        fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST',
          body: fd,
          headers: { Accept: 'application/json' },
        })
          .then((r) => r.json().then((data) => ({ ok: r.ok, data })))
          .then(({ ok, data }) => {
            if (!ok) throw new Error(data.description || data.message || 'Error');
            addLabel.textContent = addedText;
            setTimeout(() => {
              addLabel.textContent = computeAddLabel();
              addButton.disabled = false;
            }, 2000);
            return fetch('/cart.js')
              .then((r) => r.json())
              .then((cart) => {
                const cartLink = document.querySelector('.site-header__cart');
                if (!cartLink) return;
                let count = cartLink.querySelector('.site-header__cart-count');
                if (!count) {
                  count = document.createElement('span');
                  count.className = 'site-header__cart-count';
                  count.setAttribute('aria-hidden', 'true');
                  cartLink.appendChild(count);
                }
                count.textContent = cart.item_count;
              });
          })
          .catch((err) => {
            status.textContent = err.message;
            status.classList.add('is-error');
            addLabel.textContent = computeAddLabel();
            addButton.disabled = false;
          });
      });
    };
    init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-banners"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = () => {
      document.querySelectorAll('[data-name-preview]:not([data-name-init])').forEach((input) => {
        input.setAttribute('data-name-init', '');
        const promo = input.closest('.promo');
        const overlay = promo && promo.querySelector('.promo__overlay-script');
        if (!overlay) return;
        const fallback = overlay.textContent;
        let popTimer = null;
        input.addEventListener('input', () => {
          overlay.textContent = input.value.trim() || fallback;
          overlay.classList.remove('is-typing');
          void overlay.offsetWidth; /* restart the pop animation */
          overlay.classList.add('is-typing');
          clearTimeout(popTimer);
          popTimer = setTimeout(() => overlay.classList.remove('is-typing'), 300);
        });
      });
    };
    init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
  (() => {
    const init = () => {
      const el = document.querySelector('[data-related]:not([data-related-init])');
      if (!el) return;
      el.setAttribute('data-related-init', '');
      fetch(el.dataset.url)
        .then((r) => r.text())
        .then((html) => {
          const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-related]');
          if (fresh && fresh.children.length > 0) {
            el.innerHTML = fresh.innerHTML;
            if (window.PhiMotion) window.PhiMotion.refresh();
            document.dispatchEvent(new CustomEvent('phi:content-loaded'));
          }
        })
        .catch(() => {});
    };
    init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
